var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Layer from "../templates/layer";
import Box from "../templates/box";
import Flex from "../templates/flex";
import { Icon } from "../icon";
export var ModalContent = function (_a) {
    var children = _a.children, height = _a.height, width = _a.width, testId = _a.testId, _b = _a.background, background = _b === void 0 ? "mainBackground" : _b;
    return (React.createElement(Flex, { "data-testid": testId, height: height, width: width, background: background, round: true, column: true }, children));
};
export var ModalHeader = function (_a) {
    var children = _a.children, testId = _a.testId;
    return (React.createElement(Flex, { "data-testid": testId, padding: [6] }, children));
};
export var ModalBody = function (_a) {
    var children = _a.children, testId = _a.testId;
    return (React.createElement(Flex, { "data-testid": testId, padding: [0, 6], column: true }, children));
};
export var ModalFooter = function (_a) {
    var children = _a.children, testId = _a.testId, _b = _a.hasBorder, hasBorder = _b === void 0 ? true : _b;
    return (React.createElement(Flex, { column: true, padding: [0, 6], flex: 1 },
        React.createElement(Flex, { "data-testid": testId, flex: 1, padding: [6, 0], alignItems: "center", justifyContent: "end", border: hasBorder ? { size: "1px", type: "solid", side: "top", color: "borderSecondary" } : {} }, children)));
};
export var ModalCloseButton = function (_a) {
    var onClose = _a.onClose, testId = _a.testId;
    return (React.createElement(Box, { "data-testid": testId, sx: { marginLeft: "auto" }, as: Icon, name: "x", color: "border", onClick: onClose, cursor: "pointer" }));
};
var Modal = function (_a) {
    var children = _a.children, layerprops = __rest(_a, ["children"]);
    return React.createElement(Layer, __assign({}, layerprops), children);
};
export default Modal;
